<script>
    import TopicMasonryGrid from "./TopicMasonryGrid.svelte"
    export let alltopics;
</script>

<TopicMasonryGrid {alltopics}/>
